
@if (!currentData.show) {
  <div id="download-container">
    Downloading...
  </div>
}
@if (currentData.show) {
  <div class="row m-0 p-0 shadow-sm _wf-historytabmaincontainer">
    <!-- for form -->
    <div class="_arc-doc-viewer _wf-patienthistory box-shadow">
      <div class="h-100">
        @if (currentData.labReport != undefined && currentData.type=='application/pdf') {
          <ng2-pdfjs-viewer
            pdfSrc="{{currentData.labReport}}" [openFile]="false" [download]="true"
          [print]="true"></ng2-pdfjs-viewer>
        }
        @if (currentData.labReport != undefined && currentData.type!='application/pdf') {
          <app-image-viewer
            style="width: 100%; height:600px" [src]="[currentData.labReport]"
            [fileData]="currentData.imageInfo">
          </app-image-viewer>
        }
      </div>
    </div>
  </div>
}